export enum SeatProfile {
  Regular = 'Regular',
  Minor = 'Minor',
  Pet = 'Pet',
  Pregnant = 'Pregnant',
  Dependant = 'Dependant',
  Blind = 'Blind',
  Deaf = 'Deaf',
  /*Luggage = 'Luggage',
  Package = 'Package',  
  Bike = 'Bike',
  Scooter = 'Scooter'*/
}
